import { all, takeLatest, call, select, put } from 'redux-saga/effects';

import { types } from '@dragonfruit/redux/error';
import { getLocaleCode } from '@dragonfruit/redux/locale';
import { getCurrentRoute } from '@dragonfruit/redux/location';
import { getUserID } from '@dragonfruit/redux/profile';
import { home } from '@dragonfruit/redux/navigation';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';

import { sendMessage } from '@dragonfruit/services/message';

import {
  TOKEN_INVALID_ERROR_CODE_REGEX,
  ONLY_TUTOR_HAVE_AUTH,
  ONLY_STUDENT_HAVE_AUTH,
} from '@dragonfruit/constants/errorCode';
import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';

export function* handleSendMessage(error) {
  const locale = yield select(getLocaleCode);
  const url = yield select(getCurrentRoute);
  const userId = yield select(getUserID);

  const info = {
    locale,
    url,
    userId,
  };

  yield call(sendMessage, {
    error,
    info,
  });
}

export function* sendErrorFlow(action) {
  const { error } = action.payload;
  const { error_code: errorCode } = error;

  if (TOKEN_INVALID_ERROR_CODE_REGEX.test(errorCode)) {
    return;
  }

  switch (errorCode) {
    case ONLY_TUTOR_HAVE_AUTH:
    case ONLY_STUDENT_HAVE_AUTH:
      yield put(
        showAlertBanner({
          message: error.message,
          theme: ALERT_ERROR_THEME,
        })
      );
      yield put(home());

      return;
    default:
      yield put(handleSendMessage(error));
      break;
  }
}

export default function*() {
  yield all([takeLatest(types.SEND_ERROR, sendErrorFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/error.js